import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "q-gutter-sm" }

import { useStoreProfiles } from '../../store/useStoreProfiles'
import { computed, ref, shallowRef, watchEffect } from 'vue'
import FilteringDataDisplay from '../FilteringDataDisplay.vue'
import { useFilteringDisplayOptions } from '../../composables/useFilteringDisplayOptions'
import { StoreStates } from '../../pages/PageStoreProfile.vue'
import BulkUpdateRai from './BulkUpdateRai.vue'
import TaskAttachment from '../TaskAttachment.vue'
import FetchPdf from '../FetchPdf.vue'
import { useModelWrapper } from '../wrappers/helpers/useModelWrapper'
import { Table } from 'app/types/components/data-rendering'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreTasks',
  props: {
    storeId: {},
    isFetching: { type: Boolean },
    isNative: { type: Boolean },
    storeStates: {}
  },
  emits: ["update:isFetching"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const taskDataRef = ref<typeof FilteringDataDisplay | undefined>()
const isFetching = useModelWrapper(props, emit, 'isFetching')
const setFetching = (e: any) => (isFetching.value = e)

const loading = ref(true)
const taskData = shallowRef<Table>({ data: [], meta: { columns: {} } })

watchEffect(
  async () => {
    //tasks
    const { getTaskData } = useStoreProfiles()
    taskData.value = getTaskData(props.storeId)
    loading.value = false
  },
  { flush: 'post' }
)

const showChecks = computed(() => !!(props.storeStates.isThisTimer || props.isNative))
const { taskListDisplayOptions } = useFilteringDisplayOptions({
  isFetching: props.isFetching,
  showAllChecks: showChecks,
})
//bulk rai
const setBulkRaiFilter = () => {
  if (taskDataRef.value) {
    taskDataRef.value.addCondition({
      col: 'task_start_date',
      operation: 'onOrBefore',
      dateModifier: 'today',
      value: null,
    })
    taskDataRef.value.addCondition({
      col: 'order_type',
      operation: 'isNot',
      value: 'MERCH',
    })
  }
}
const uncheckTaskData = () => {
  if (taskDataRef.value) {
    taskDataRef.value.unCheckAll()
  }
}

return (_ctx: any,_cache: any) => {
  return (taskData.value)
    ? (_openBlock(), _createBlock(FilteringDataDisplay, {
        ref_key: "taskDataRef",
        ref: taskDataRef,
        key: `${_ctx.storeId}-${loading.value}`,
        "is-loading": loading.value,
        "table-data": taskData.value,
        options: _unref(taskListDisplayOptions),
        collapse: true
      }, _createSlots({ _: 2 }, [
        (taskDataRef.value)
          ? {
              name: "attachment",
              fn: _withCtx(({ rowData, filterData }) => [
                _createVNode(TaskAttachment, {
                  truncate: "",
                  attachment: rowData['attachment'],
                  "filter-data": filterData
                }, null, 8, ["attachment", "filter-data"])
              ]),
              key: "0"
            }
          : undefined,
        (_ctx.isNative || _ctx.storeStates.isThisTimer)
          ? {
              name: "actions",
              fn: _withCtx(({ checkedData }) => [
                _createElementVNode("div", _hoisted_1, [
                  (_ctx.isNative)
                    ? (_openBlock(), _createBlock(FetchPdf, {
                        key: 0,
                        data: checkedData,
                        field: "attachment",
                        onIsFetching: setFetching
                      }, null, 8, ["data"]))
                    : _createCommentVNode("", true),
                  (_ctx.storeStates.isThisTimer)
                    ? (_openBlock(), _createBlock(BulkUpdateRai, {
                        key: 1,
                        tasks: checkedData,
                        onSetBulkRaiFilter: setBulkRaiFilter,
                        onBulkDataChange: uncheckTaskData
                      }, null, 8, ["tasks"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              key: "1"
            }
          : undefined
      ]), 1032, ["is-loading", "table-data", "options"]))
    : _createCommentVNode("", true)
}
}

})